import React, { memo } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AcceptCookies } from './components/acceptCookies/acceptCookies';
import { useAuthRedirect } from './routes/useAuthRedirect';
import { useDatastoreErrors } from './helpers/useDatastoreErrors';
import { useServiceWorkerUpdate } from './helpers/useServiceWorkerUpdate';
import { lightTheme, darkTheme } from './theme/theme';
import { ThemeDomain } from './components/toggleThemeSwitch/theme.domain';
import { di } from './state/inversify.config';

export const AppMemo = memo(() => {
  const themeDomain = di.get<ThemeDomain>(ThemeDomain);

  useAuthRedirect();
  useDatastoreErrors();
  useServiceWorkerUpdate();
  const theme = themeDomain.useThemeSelector();
  return (
    <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
      <AcceptCookies />
      <Outlet />
    </ThemeProvider>
  );
});
